import { useEffect } from "react";
import { useSite } from "../lib/store";

const setMeta = (attr, key, val) => {
  if (!val) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", val);
};

export const useSeo = ({ title, description, image, jsonLd, noindex = false } = {}) => {
  const { site } = useSite();
  const seo = site?.settings?.seo || {};
  useEffect(() => {
    const t = title ? `${title} | Hravá mateřinka` : seo.title || "Hravá mateřinka";
    const d = description || seo.description;
    document.title = t;
    setMeta("name", "description", d);
    setMeta("name", "keywords", seo.keywords);
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large");
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:url", window.location.href);
    if (image) setMeta("property", "og:image", image);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = window.location.origin + window.location.pathname;
    const old = document.getElementById("page-jsonld");
    if (old) old.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "page-jsonld";
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, image, seo.title, seo.description, seo.keywords, jsonLd, noindex]);
};
